<template>
    <div class="container-fluid">
        <h1>{{`${$t('components.stocklist.title')} ${$t('components.stocklist-transit.title')}`}}</h1>
        <div class="row">
            <div class="col-sm-12">
                <div class="row">
                    <div class=" container-fluid bg-white shadow-sm">
                        <section class="mb-5">
                            <div class="row mt-4">
                                <div class="col-sm-12 col-md-3 border-right">
                                    <h5 class="text-center">{{$t('components.stocklist.filters')}}</h5>
                                    <hr>
                                    <button class="btn btn-sm btn-wos-real w-100" @click="clearFilters">
                                        {{$t('components.stocklist.btnClearFilters')}}
                                    </button>
                                    <div class="row mt-2">
                                        <div class="col-sm-12">
                                            <div class="card">
                                                <div class="card-header">
                                                    <h4 class="card-title">{{$t('components.stocklist.filterProducts')}}</h4>
                                                </div>
                                                <div class="card-body text-sm noselect onhover" style="max-height: 350px; overflow-y: scroll">
                                                    <div v-for="(item, index) in productFilters" :key="index" class="mb-2">
                                                        <label><input type="checkbox" v-model="item.checked" :value="item.value"/>
                                                            {{item.name}}</label>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <button class="btn btn-sm btn-wos-real w-100" @click="applyFilters">
                                                        {{$t('components.stocklist.btnApplyFilters')}}
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="card mt-2">
                                                <div class="card-header">
                                                    <h4 class="card-title">{{$t('components.stocklist.warehouse') | capitalize}}</h4>
                                                </div>
                                                <div class="card-body text-sm noselect onhover" style="max-height: 350px; overflow-y: scroll">
                                                    <div v-for="(item, index) in warehouseFilters" :key="index" class="mb-2">
                                                        <label><input type="checkbox" v-model="item.checked" :value="item.value"/>
                                                            {{item.name}}</label>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <button class="btn btn-sm btn-wos-real w-100" @click="applyFilters">
                                                        {{$t('components.stocklist.btnApplyFilters')}}
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="card mt-2" v-for="(item, index) in characteristicFilters" :key="index">
                                                <div class="card-header">
                                                    <h4 class="card-title">{{item.name}}</h4>
                                                </div>
                                                <div class="card-body text-sm noselect" style="max-height: 350px; overflow-y: scroll">
                                                    <div v-for="(characteristic, index2) in item.values" :key="index2" class="mb-2">
                                                        <label><input type="checkbox" v-model="characteristic.checked" :value="characteristic.option_value_id"/>
                                                            {{characteristic.name}}</label>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <button class="btn btn-sm btn-wos-real w-100" @click="applyFilters">
                                                        {{$t('components.stocklist.btnApplyFilters')}}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-9">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-4 text-wellis-gold">
                                            {{$t('components.stocklist.dataLength', {len: dataLength, time: fetchTimeComputed})}}
                                        </div>
                                        <div class="col-sm-12 offset-md-4 col-md-4">
                                            <input class="form-control form-control-sm mb-2" type="text" :placeholder="$t('components.topbar.search')" v-model="quickSearch"/>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="row">
                                                <div class="col-sm-12 w-100" style="overflow-x: scroll">
                                                    <table class="table table-striped table-hover">
                                                        <thead>
                                                        <th>{{$t('components.stocklist.name') | capitalize}}</th>
                                                        <th>{{$t('components.products.catalogNoShort') | capitalize}}</th>
                                                        <th>{{$t('components.stocklist.configNoShort') | capitalize}}</th>
                                                        <th>{{$t('components.stocklist.serialNoShort') | capitalize}}</th>
                                                        <th>{{$t('components.products.quantity') | capitalize}}</th>
                                                        <th>{{$t('components.products.price') | capitalize}}</th>
                                                        <th>{{$t('components.stocklist.acrylicColor') | capitalize}}</th>
                                                        <th>{{$t('components.stocklist.cabinetColor') | capitalize}}</th>
                                                        <th>{{$t('components.stocklist.warehouse') | capitalize}}</th>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="item in filteredResults" :key="item.configNo+'_'+item.catalogNo+'_'+item.serialNo"
                                                            class="">
                                                            <td>
                                                                <router-link class="text-wellis-gold font-weight-bold" :to="{name: 'app.stocklist.transit.view', params: {
                                                                    uniqueId: item.uniqueId
                                                                }}">
                                                                    {{item.name | cut(14)}}
                                                                </router-link>
                                                            </td>
                                                            <td>
                                                                <router-link :to="{name: 'app.stocklist.transit.view', params: {
                                                                    uniqueId: item.uniqueId
                                                                }}">
                                                                    {{item.catalogNo}}
                                                                </router-link>
                                                            </td>
                                                            <td class="text-wellis-gold font-weight-bold cursor-button" @click="viewConfiguration(item)">
                                                                {{item.configNo}} <i class="fa fa-eye"></i>
                                                            </td>
                                                            <td class="text-wellis-gold font-weight-bold">{{item.serialNo}}</td>
                                                            <td>{{`${item.quantity} ${item.unit}`}}</td>
                                                            <td class="text-wellis-gold font-weight-bold">
                                                                <div v-if="hasPrice(item)">
                                                                    <small class="text-black-50 d-block" v-if="item.price.vat">
                                                                        {{item.price.unitPrice * item.quantity | toPrice(item.price.currency, false)}} +
                                                                        {{$t('components.products.vat')}}
                                                                    </small>
                                                                    {{item.price.unitPrice * item.quantity | toPrice(item.price.currency, item.price.vat)}}
                                                                </div>
                                                                <div v-else>
                                                                    -
                                                                </div>
                                                            </td>
                                                            <td>{{item.acrylicColor}}</td>
                                                            <td>{{item.cabinetColor}}</td>
                                                            <td class="text-wellis-gold font-weight-bold">{{item.warehouse}}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {empty} from "../../../helpers";
import StocklistApiService from "../../../api/stocklist.api";
import {EVENT_LANG_CHANGE} from "../../../core/constants";
import ExplorerHistory from "@/modules/explorer";

export default {
    name: "StocklistTransit",

    mounted() {
        if (!this.$store.getters['authStore/fromUSA']) {
            return this.$router.push({
                name: 'app.stocklist'
            });
        }

        ExplorerHistory.resolve(this).then(result => {
            if (!result) {
                this.bootstrap();
            }
        });

        this.$eventBus.$on(EVENT_LANG_CHANGE, () => {
            this.bootstrap();
        });
    },

    destroyed() {
        this.$eventBus.$off(EVENT_LANG_CHANGE);
    },

    beforeRouteLeave(to, from, next) {
        let loader = this.$loading.show();
        ExplorerHistory.saveCurrentState(this, from, window.pageYOffset, this.viewTitle, true).then(() => {
            loader.hide();
            next();
        });
    },

    data() {
        return {
            viewTitle: 'components.stocklist-transit.title',
            stocklist: [],
            quickSearch: null,
            filters: {
                category: [],
                product: [],
                warehouse: [],
                characteristics: []
            },
            fetchTime: 0,
        }
    },


    methods: {
        bootstrap(filters = null) {
            let loader = this.$loading.show();
            let fetchStartTime = Date.now();
            StocklistApiService.getTransit(filters)
                .then(response => {
                    this.$set(this, 'stocklist', Object.values(response.data.stocklist));
                    if (filters === null) {
                        this.filters.product = response.data.filters.product;
                        this.filters.warehouse = response.data.filters.warehouse;
                        this.filters.characteristics = Object.values(response.data.filters.characteristics);
                    }
                    this.$scrollTop();
                    this.fetchTime = Date.now() - fetchStartTime;
                })
                .catch(() => {
                    this.$swal.fire({
                        icon: "error",
                        allowOutsideClick: false,
                        html: this.$t('components.stocklist.notready')
                    });
                })
                .finally(() => {
                    loader.hide();
                    loader = null;
                });
        },

        clearFilters() {
            this.filters.product.map(item => item.checked = false);
            this.filters.characteristics.map(item => item.values.map(char => char.checked = false));
            this.bootstrap();
        },

        applyFilters() {
            let filters = {
                product: [],
                warehouse: [],
                characteristics: {},
            };
            this.filters.product.map(item => {
                if (item.checked) {
                    filters.product.push(item.value);
                }
            });

            this.filters.warehouse.map(item => {
                if (item.checked) {
                    filters.warehouse.push(item.value);
                }
            });

            this.filters.characteristics.map(char => {
                char.values.map(item => {
                    if (item.checked) {
                        if (typeof filters.characteristics[char.characteristic_id] === 'undefined') {
                            filters.characteristics[char.characteristic_id] = [];
                        }
                        filters.characteristics[char.characteristic_id].push(item.option_value_id);
                    }
                })
            });

            this.bootstrap(filters);
        },

        viewConfiguration(item) {
            let loader = this.$loading.show();
            StocklistApiService.transitDetails(item.uniqueId, {
                with_configuration: true
            }).then(response => {
                let body = '<h3 class="float-left">' + item.name + ' #' + item.configNo + '</h3><table class="table table-bordered">'
                    + '<tbody>';
                Object.values(response.data.product.configuration).forEach(line => {
                    let value = line.values.find(x => line.selectedValue === x.optionValueId);
                    if (value) {
                        value = value.description;
                    }
                    body += `<tr><td>${line.description}</td><td>${value || line.selectedValue}</td></tr>`;
                })
                this.$swal.fire({
                    html: body + '</tbody></table>',
                    width: "48em"
                });
            }).finally(() => {
                loader.hide();
                loader = null;
            });
        }
    },

    computed: {
        stockList() {
            return this.stocklist;
        },

        filteredResults() {
            let items = [];
            this.stockList.forEach(item => {
                if (!empty(this.quickSearch)) {
                    let r = new RegExp(this.quickSearch, "iu");
                    if (r.test(item.name) || r.test(item.catalogNo)) {
                        items.push(item);
                    }
                } else {
                    items.push(item);
                }
            });

            items.sort(function (a, b) {
                return a.name > b.name;
            });

            return items;
        },

        productFilters() {
            return this.filters.product;
        },

        characteristicFilters() {
            return this.filters.characteristics;
        },

        hasPrice() {
            return item => {
                return item.price && typeof item.price !== 'undefined';
            }
        },

        warehouseFilters() {
            return this.filters.warehouse;
        },

        dataLength() {
            return this.stockList.length;
        },

        fetchTimeComputed() {
            return (Math.abs(this.fetchTime) / 1000).toFixed(2);
        },

    }
}
</script>

<style scoped>
.text-sm {
    font-size: 13px;
}

input[type="checkbox"] {
    opacity: 1;
}
</style>
